import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { uiLoad } from 'portal/store/ui/actions'

export const useUILoader = () => {
  const dispatch = useDispatch()

  const reload = useCallback(() => {
    dispatch(uiLoad())
  }, [dispatch])

  useEffect(() => {
    reload()
  }, [reload])

  const { loading, error, items } = useSelector((state: any) => {
    return state.ui
  })

  return {
    loading,
    error,
    items,
    reload
  }
}
